import { Card, Space } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import DocumentArchiveDataTable from '../../components/datatables/DocumentArchiveDataTable';
import Breadcrumbs from '../../config/Breadcrumbs';
import Routes from '../../config/Routes';
import InstitutionDTO from '../../models/InstitutionDTO';
import UserSecurity from '../../models/UserSecurity';
import HeaderPortal from '../../portals/HeaderPortal';
import { StateStoreModel } from '../../redux/state/StateStoreModel';
import HistoryUtil from '../../utils/HistoryUtil';

interface DocumentArchiveListPageState {
}

interface ADocumentArchiveListPageProps {
  currentUser: UserSecurity | null;
  selectedInstitution: InstitutionDTO | null;
}

class DocumentArchiveListPage extends React.Component<ADocumentArchiveListPageProps & RouteComponentProps<RouteObject>, DocumentArchiveListPageState> {

  constructor(props: ADocumentArchiveListPageProps & RouteComponentProps<RouteObject>) {
    super(props);
  }

  private onBack = () => {
    HistoryUtil.push(Routes.generate(Routes.ACADEMIC_YEARS, {}, {}));
  }

  render() {
    return (
      <Content >
        <HeaderPortal title='Document Archive' breadcrumbs={Breadcrumbs.documentArchive()}
          onBack={this.onBack} />
        <Space direction="vertical" size="large">
          <Card title="Document Archive">
            <Space direction='vertical' size="large">
              <DocumentArchiveDataTable />
            </Space>
          </Card>
        </Space>
      </Content>
    );
  }
}

function mapStateToProps(state: StateStoreModel) {
  return {
    currentUser: state.UserSession.Value,
    selectedInstitution: state.Institution.Selected
  };
}

export default withRouter(connect(mapStateToProps)(DocumentArchiveListPage));
